export default function FilterCollapseBuilder() {

    const $container = $('.v-builder__elements--collapse');
    const $filter = $('.v-builder__elements--collapse .filter');
    const $btn = $('.v-builder__elements--collapse .filter button')

    //COLLAPSE
    if ($container.length > 0) {
        $('.c-collapse__item--btn').click(function () {

            const $close_btn = $(this).find('.close');
            const $current_item = $(this).closest('.c-collapse__item');
            const $all_item = $(this).closest('.c-collapse').find('.c-collapse__item');
            const $current_content = $(this).next('.c-collapse__item--content');
            const $active_class = 'js-isActive';

            $all_item.not($current_item).each(function () {
                $(this).removeClass($active_class);
                $(this).find('.close').removeClass($active_class);
                $(this).find('.c-collapse__item--content').slideUp(400);
                TweenMax.to($(this).find('.close'), .3, {rotation: 0, ease: Power2.easeInOut});
            });

            if (!$current_item.hasClass($active_class)) {

                $current_item.addClass($active_class);
                $close_btn.addClass($active_class);
                $current_content.slideDown(400);
                TweenMax.to($close_btn, .3, {rotation: 45, ease: Power2.easeInOut});

            }
        });
    }

    //FILTER
    if ($container.length > 0 && $filter.length > 0) {

        $btn.click(function () {
            const $slug = $(this).attr('data-collapse-filter');
            const $item = $(this).closest('.v-builder__elements--collapse').find('.c-collapse__item');
            const $filter = '.filter';
            const $btn = 'button';
            const $active_class = 'js-isActive';


            $(this).closest($filter).find($btn).each(function () {
                if ($(this).hasClass($active_class)) {
                    $(this).removeClass($active_class);
                }
            });

            if (!$(this).hasClass($active_class)) {
                $(this).addClass($active_class);
            }

            if ($slug === '*') {
                $item.each(function () {
                    $(this).slideDown(400);
                });
            } else {
                $item.each(function () {

                    if (!$(this).hasClass($slug)) {
                        $(this).slideUp(400);
                    } else {
                        $(this).slideDown(400);
                    }
                });
            }
        })
    }
}
